// API Configuration
export const API_BASE_URL = 'https://kiaelectromotor.com/api';

export const apiEndpoints = {
  // Auth
  login: `${API_BASE_URL}/auth.php`,

  // Products
  products: `${API_BASE_URL}/products.php`,
  productImages: `${API_BASE_URL}/product-images.php`,
  categories: `${API_BASE_URL}/categories.php`,

  // Content
  about: `${API_BASE_URL}/about.php`,
  representatives: `${API_BASE_URL}/representatives.php`,
  customers: `${API_BASE_URL}/customers.php`,
  blogs: `${API_BASE_URL}/blogs.php`,
  contacts: `${API_BASE_URL}/contacts.php`,
  executiveSections: `${API_BASE_URL}/executive-sections.php`,
  certificates: `${API_BASE_URL}/certificates.php`,
  settings: `${API_BASE_URL}/settings.php`,

  // Upload
  upload: `${API_BASE_URL}/upload.php`,
};

// Converts relative API paths like "/api/uploads/..." to an absolute URL on kiaelectromotor.com
export function resolveApiAssetUrl(input?: string | null): string | null {
  if (!input) return null;
  // Static article/certificate assets are versioned as local WebP files.
  // Keep the database paths compatible while avoiding the heavier PNG/JPEG.
  if (/^\/images\/.*\.(?:png|jpe?g)$/i.test(input)) {
    input = input.replace(/\.(?:png|jpe?g)$/i, '.webp');
  }
  try {
    return new URL(input, API_BASE_URL).toString();
  } catch {
    return input;
  }
}

// Build a real resized WebP URL for uploaded API images so small cards do not
// download the original full-size JPG.
export function responsiveApiAssetUrl(input: string | null | undefined, width: number, quality = 78): string | null {
  const resolved = resolveApiAssetUrl(input);
  if (!resolved) return null;

  try {
    const url = new URL(resolved);
    const apiUrl = new URL(API_BASE_URL);
    if (url.origin !== apiUrl.origin || !url.pathname.startsWith('/api/uploads/')) return resolved;

    const source = url.pathname.slice('/api/'.length);
    const params = new URLSearchParams({ src: source, w: String(Math.max(96, Math.round(width))), q: String(quality) });
    return `${API_BASE_URL}/image?${params.toString()}`;
  } catch {
    return resolved;
  }
}

// API helper functions
export async function apiRequest<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {
  const defaultHeaders: HeadersInit = {
    'Content-Type': 'application/json',
  };

  const response = await fetch(endpoint, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
    credentials: 'include',
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'خطا در ارتباط با سرور');
  }

  return data;
}

export async function uploadFile(file: File, folder: string = 'products'): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', folder);

  const response = await fetch(apiEndpoints.upload, {
    method: 'POST',
    body: formData,
    credentials: 'include',
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'خطا در آپلود فایل');
  }

  return resolveApiAssetUrl(data.url) || data.url;
}
